import { NgModule } from '@angular/core';
import { AppApiModule } from '../services/api.module';
import { SharedModule } from '../shared/shared.module';
import { JobProgressDialogComponent } from './components/job-progress-dialog/job-progress-dialog.component';
import { JobProgressComponent } from './components/job-progress/job-progress.component';
import { InsightsJobsStateModule } from './insights-jobs-state.module';

@NgModule({
  imports: [
    SharedModule,

    AppApiModule,

    InsightsJobsStateModule
  ],
  exports: [
    JobProgressComponent,
    JobProgressDialogComponent
  ],
  declarations: [
    JobProgressComponent,
    JobProgressDialogComponent
  ],
  providers: [
  ]
})
export class InsightsJobsModule { }
